export const secondaryLineItemConstants = {
  SECONDARY_LINE_ITEM_CREATE_LOADING: 'SECONDARY_LINE_ITEM_CREATE_LOADING',
  SECONDARY_LINE_ITEM_CREATE_SUCCESS: 'SECONDARY_LINE_ITEM_CREATE_SUCCESS',
  SECONDARY_LINE_ITEM_CREATE_FAILURE: 'SECONDARY_LINE_ITEM_CREATE_FAILURE',
  SECONDARY_LINE_ITEM_ERROR_RELOAD: 'SECONDARY_LINE_ITEM_ERROR_RELOAD',

  SECONDARY_LINE_ITEM_LIST_LOADING: 'SECONDARY_LINE_ITEM_LIST_LOADING',
  SECONDARY_LINE_ITEM_LIST_SUCCESS: 'SECONDARY_LINE_ITEM_LIST_SUCCESS',
  SECONDARY_LINE_ITEM_LIST_FAILURE: 'SECONDARY_LINE_ITEM_LIST_FAILURE',

  SECONDARY_LINE_ITEM_EDIT_LOADING: 'SECONDARY_LINE_ITEM_EDIT_LOADING',
  SECONDARY_LINE_ITEM_EDIT_SUCCESS: 'SECONDARY_LINE_ITEM_EDIT_SUCCESS',
  SECONDARY_LINE_ITEM_EDIT_FAILURE: 'SECONDARY_LINE_ITEM_EDIT_FAILURE',

  SECONDARY_LINE_ITEM_DELETE_LOADING: 'SECONDARY_LINE_ITEM_DELETE_LOADING',
  SECONDARY_LINE_ITEM_DELETE_SUCCESS: 'SECONDARY_LINE_ITEM_DELETE_SUCCESS',
  SECONDARY_LINE_ITEM_DELETE_FAILURE: 'SECONDARY_LINE_ITEM_DELETE_FAILURE'
};
